import React from 'react';
import { FileIcon } from 'elements/Icon';

const AVI = () => (
  <FileIcon>
    <path d="M98,2v136H2V2H98 M100,0H0v140h100V0L100,0z"/>
    <rect x="12.448" y="102.874" width="74" height="24"/>
    <path d="M29.995,36v52.006l40.862-26.003L29.995,36z"/>
    <g>
      <path fill="#FFFFFF" className="text" d="M35.495,118.296h2.367v2.336h-2.367V118.296z"/>
      <path fill="#FFFFFF" className="text" d="M43.452,109.117h2.723l4.074,11.516H47.64l-0.76-2.367h-4.241l-0.78,2.367h-2.517L43.452,109.117z
        M43.294,116.281h2.949l-1.455-4.531L43.294,116.281z"/>
      <path fill="#FFFFFF" className="text" d="M57.272,109.117h2.5l-3.926,11.516h-2.273l-3.895-11.516h2.57l2.5,8.742L57.272,109.117z"/>
      <path fill="#FFFFFF" className="text" d="M63.401,120.632H61.01v-11.516h2.391V120.632z"/>
    </g>
  </FileIcon>
);

export default AVI;



// WEBPACK FOOTER //
// ./src/core/icons/components/files/AVI.jsx